function toMinutesAMPM(timeStr) {
  const [time, modifier] = timeStr.trim().split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return hours * 60 + minutes;
}

function isWithinSchedule(schedule) {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();
  const currentTimeInMinutes = currentHour * 60 + currentMinutes;

  return schedule.some(({ opensAt, closesAt }) => {
    const startTime = toMinutesAMPM(opensAt);
    const endTime = toMinutesAMPM(closesAt);

    return currentTimeInMinutes >= startTime && currentTimeInMinutes < endTime;
  });
}

  module.exports = {
    isWithinSchedule
  };